/**
 * Numeric precision policy.
 *
 * JavaScript's `number` type is IEEE-754 double and loses precision at the
 * 16th significant digit — unacceptable for a financial ledger. Every monetary
 * value in this system is represented as a `Decimal` (decimal.js) in memory
 * and as `DECIMAL(p,s)` in PostgreSQL. This file is the single source of
 * truth for the `(p,s)` pair of each value class; changing these requires a
 * DB migration.
 */

/** Token balances and token deltas — matches `users.<token>` columns. */
export const TOKEN_DECIMALS = 18;
export const TOKEN_SQL_TYPE = 'DECIMAL(36, 18)';

/** Fiat amounts (MYR, USD, CNY) used in recharge and withdraw flows. */
export const FIAT_DECIMALS = 6;
export const FIAT_SQL_TYPE = 'DECIMAL(18, 6)';

/** Ratios, percentages, multipliers. */
export const RATIO_DECIMALS = 8;
export const RATIO_SQL_TYPE = 'DECIMAL(10, 8)';

/** Minimum display precision in the UI (UI rounds to this; ledger keeps full). */
export const UI_DISPLAY_DECIMALS = 4;
